import * as React from 'react';
import { SVGProps } from 'react';

const IconHamburgerSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14 5H2V3h12v2zm0 4H2V7h12v2zM2 13h12v-2H2v2z" />
  </svg>
);
export default IconHamburgerSizeS;
